var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.0566,
    y: 21.0566,
    width: 21.0566,
    height: 21.0566,
    rx: 10.5283,
    transform: "rotate(-180 21.0566 21.0566)",
    fill: "#D83232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5725 11.8175C13.8294 11.5605 14.2461 11.5605 14.503 11.8175C14.76 12.0744 14.76 12.4911 14.503 12.748L10.9936 16.2575C10.7366 16.5144 10.32 16.5144 10.063 16.2575L6.55359 12.748C6.29661 12.4911 6.29661 12.0744 6.55359 11.8175C6.81056 11.5605 7.22719 11.5605 7.48417 11.8175L9.87029 14.2036L9.87029 5.70255C9.87029 5.33914 10.1649 5.04453 10.5283 5.04453C10.8917 5.04453 11.1863 5.33914 11.1863 5.70255L11.1863 14.2036L13.5725 11.8175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossArrowIcon);
export default __webpack_public_path__ + "static/media/LossArrowIcon.b7ff54fb4658896982dca61c5f33dc57.svg";
export { ForwardRef as ReactComponent };